<template>
  <div id="configure-saml-step">
    <div>
      <p class="text-lighter mb-20">Find this information through your SSO provider.</p>

      <ValidationProvider
        v-slot="{ errors: validationErrors }"
        name="entity_id"
        rules="required"
        mode="eager"
      >
        <div :class="{ 'has-error': validationErrors[0] || sso.errors?.entity_id }">
          <label class="control-label is-uppercase">
            Issuer ID
            <abbr title="required">*</abbr>
          </label>
          <!-- eslint-disable vue/no-mutating-props -->
          <AppInput
            v-model="sso.entity_id"
            required
            placeholder="Enter issuer ID"
            :value="sso.entity_id"
          />
          <!-- eslint-enable vue/no-mutating-props -->
          <span class="help-block">{{ sso.errors?.entity_id?.toLowerCase() || validationErrors[0] }}</span>
        </div>
      </ValidationProvider>

      <ValidationProvider
        v-slot="{ errors: validationErrors }"
        name="sso_url"
        rules="required"
      >
        <div :class="{ 'has-error': validationErrors[0] || sso.errors?.sso_url }">
          <label class="control-label is-uppercase">
            SSO URL
            <abbr title="required">*</abbr>
          </label>
          <!-- eslint-disable vue/no-mutating-props -->
          <AppInput
            v-model="sso.sso_url"
            required
            placeholder="Enter single sign-on URL"
            :value="sso.sso_url"
          />
          <!-- eslint-enable vue/no-mutating-props -->
          <span class="help-block">{{ sso.errors?.sso_url?.toLowerCase() || validationErrors[0] }}</span>
        </div>
      </ValidationProvider>

      <ValidationProvider
        v-slot="{ errors: validationErrors }"
        name="full_certificate"
        rules="required|base64certificate"
      >
        <div :class="{ 'has-error': validationErrors[0] || sso.errors?.full_certificate }">
          <label class="control-label is-uppercase">
            Identity Provider Certificate
            <abbr title="required">*</abbr>
            <i
              v-tooltip="{ placement: 'top' }"
              title="Please upload Base64 certificate."
              class="hi hi-info-filled hi-12 hi-tooltip text-grey ml-5"
            />
          </label>
          <!-- eslint-disable vue/no-mutating-props -->
          <textarea
            id="full_certificate"
            v-model="sso.full_certificate"
            class="sso-full-certificate-input form-control text"
            rows="4"
            placeholder="Copy and paste certificate"
          />
          <!-- eslint-enable vue/no-mutating-props -->
          <span class="help-block mb-0">{{ sso.errors?.full_certificate?.toLowerCase() || validationErrors[0] }}</span>
          <p class="text-lighter mt-5">
            Or
            <a
              href="#"
              @click.prevent="$refs.fileInput.click()"
            >upload full certificate</a>
            file instead
          </p>
          <input
            ref="fileInput"
            class="sso-certificate-input"
            type="file"
            accept=".pem,.crt,.cer,.cert"
            @change="handleFileUpload"
          />
        </div>
      </ValidationProvider>

      <ValidationProvider
        v-slot="{ errors: validationErrors }"
        name="domains"
        rules="required"
      >
        <div
          class="mb-30"
          :class="{ 'has-error': validationErrors[0] || sso.errors?.domains }"
        >
          <label class="control-label is-uppercase">
            Provide domains
            <abbr title="required">*</abbr>
            <i
              v-tooltip="{ placement: 'top' }"
              title="Members with these domains in their email address will be able to login into the app with SSO"
              class="hi hi-info-filled hi-12 hi-tooltip text-grey ml-5"
            />
          </label>
          <!-- eslint-disable vue/no-mutating-props -->
          <AppInput
            v-model="sso.domains"
            required
            placeholder="Enter one or more domains"
            :value="Array.isArray(sso.domains) ? sso.domains.join(', ').toLowerCase() : sso.domains"
          />
          <!-- eslint-enable vue/no-mutating-props -->
          <span class="help-block mb-0">{{ sso.errors?.domains?.toLowerCase() || validationErrors[0] }}</span>
          <span class="is-muted">Separate multiple domains with a comma</span>
        </div>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate';

extend('base64certificate', {
  validate(value) {
    const base64Regex = /^[A-Za-z0-9+/\s=-]+$/;

    return base64Regex.test(value);
  },
  message: 'Please upload Base64 certificate.',
});

export default {
  name: 'ConfigureSamlStep',
  props: {
    sso: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fileInput: null,
    };
  },
  methods: {
    handleFileUpload() {
      const file = this.$refs.fileInput.files[0];

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          // eslint-disable-next-line vue/no-mutating-props
          this.sso.full_certificate = e.target.result;
          this.$refs.fileInput.value = '';
        };
        reader.readAsText(file);
      }
    },
  },
};
</script>
